
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {loaderBar , apibaseURl , loggedInCustomerDetails , currencySymbol , changeDateFotmate} from "../../../functions/Function";
const Buyorders = (props) => {
  const [data, setData] = useState({});
  const [isLoading, setisLoading] = useState(true);
  const fetchData = () => {
    fetch(apibaseURl + "getbuyorder/"+loggedInCustomerDetails('id')+"?type=buy")
      .then(res => res.json())
      .then((result) => {
        if (result.result == true) {
            console.log(result);
            setisLoading(false);
            setData(result.response);
          }
      }
      )
  } 

  useEffect(() => {
    fetchData();
   }, [])


  return (
    <>
           <div className="tab-pane fade active show" id="nav-all">
            <table className="table table-borderless final-table mb-0 ivo-table-responsive">
              <thead>
              
                <tr className="trade-tablke-header">
                  <th scope="col">Name</th>
                  <th scope="col">Unit Price</th>
                  <th scope="col">Qty</th>
                  <th scope="col">Total</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
              {isLoading == true && 
                <tr>
                    <td colSpan={5} className="text-center data-not-found">{loaderBar(100 , 25)}</td>
                </tr>
              }
              {isLoading == false && 
              <>  
                  { Object.keys(data).length > 0  ? data.map((row, i) => (
                <tr key={row.id} className="final-table-tr">
                  <td data-label="Name" className="final-table-heading">
                    <div className="d-flex">
                      <div>
                          {row.order_type == 'Purchase' && <span className="badge finlal-table-badge">BUY</span> }
                          {row.order_type == 'Sell' && <span className="badge finlal-table-badge sellbtncustom">Sell</span> }
                        </div>
                      <div className="final-heading-left">
                        <h5>{row.product_name}</h5>
                        <div className="final-inner-heading">
                          {changeDateFotmate(row.order_date , 'MMMM Do YYYY, h:mm:ss a')}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td data-label="Unit Price"><span>{currencySymbol()}{row.amount} </span></td>
                  <td data-label="Qty">{row.qty}</td>
                  <td data-label="Total">{currencySymbol()}{row.total_amount}</td>
                  <td data-label="Status">

                    
                    {row.order_status == 'Completed' && <span className="badge finlal-table-badge">COMPELTED</span> }
                    {row.order_status == 'Cancelled' && <span className="badge finlal-table-badge cancelde-badge">CANCELED</span> }
                    {row.order_status == 'Pending' && <span className="badge finlal-table-badge pending-badge">PENDING</span> }
                    
                    
                  </td>
                </tr>
                
                  ))
                  : 
                  <tr>
                        <td colSpan={5} className="text-center data-not-found">Data Not Found</td>
                  </tr>
                  } 
              </>
              }
                </tbody>
            </table>
          </div>
    </>

  );
}

export default Buyorders;
